
export const userColumns = [
  { 
    field: "_id", 
    header: "User Id",
    accessor: (row,handleCellClick) => (
        <>
          <div onClick={()=>handleCellClick(row,"_id")}  className="cursor-pointer text-blue-600 hover:text-blue-800">
            <p>{row?._id}</p>            
          </div>
        </>
      ),

   },
  { 
    field: "Store Name", 
    header: "name",
    accessor: (row) => (
        <>
          <div  className="cursor-pointer">
            
            <p className="truncate w-[8rem]">{row?.first_name||row?.orderDetails[0]?.product?.name}</p>            
          </div>
        </>
      ),

   },
  
  { field: "email", header: "Email",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.email}
          </p>
        </div>
      </>
    ),
   },
  { field: "phone_number", header: "Contact No",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.phone_number}
          </p>
        </div>
      </>
    ),
   },
  
  { field: "average_rating", header: "Rating",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.average_rating}
          </p>
        </div>
      </>
    ),
   },
   { field: "address", header: "Address",
    accessor: (row) => (
      <>
        <div>          
          <p className="px-2">
           {row?.address}
          </p>
        </div>
      </>
    ),
   },
  
];

export const searchBy = {
    filterType: "Sort By",
    inputName: "search_by",
    options: [
      {
        name: "Descending ",
        code: "desc",
      },
      {
        name: "Ascending",
        code: "asc",
      },
    ],
  };
  
  export  const filters = [
    {
      filterType: "Gender",
      inputName: "gender",
      options: [
        {
          name: "Male",
          code: "Male",
        },
        {
          name: "Female",
          code: "Female",
        },
        {
          name: "Others",
          code: "Others",
        },
      ],
    },
    {
      filterType: "Country",
      inputName: "country",
      options: [],
    },
    {
      filterType: "City",
      inputName: "city",
      options: [],
    },
   
  ]
  
  export const canlenderFilter={
    filterType:"Created",
    inputName:"createdAt",  
    maxDate :new Date()
  }
  
  
  
  
   
  


export default {  
    filters:filters,
    SearchBy:searchBy  ,
    // WeekRange:WeekRange,
    // MonthRange:MonthRange,
    canlenderFilter:canlenderFilter,    
  }